import { Link } from 'react-router-dom';
import { isOrderRecentlyEnteredQueue } from '../../../../utils/order/orderDisplayTime';
import { PendingKeywordHighlight } from './PendingKeywordHighlight';
import { PendingThemeBadge } from './PendingThemeBadge';

/**
 * 待办列表「订单编号」列：订单号；可选 NEW 标记（刚进入当前待办栏）
 */
const PendingOrderIdCell = ({
	orderId,
	orderMongoId,
	badgeVariant,
	linkClassName,
	onOrderClick,
	order,
	to,
	linkState,
	fullWidth = true,
}) => {
	const linkColorClass = linkClassName ?? `link-${badgeVariant}`;
	const recentlyEntered = order ? isOrderRecentlyEnteredQueue(order) : false;
	const href = to || '#';

	return (
		<div className={`d-flex ${fullWidth ? 'w-100' : ''} justify-content-start align-items-center flex-nowrap gap-1 text-nowrap text-start`}>
			<Link
				to={href}
				state={linkState}
				onClick={(e) => {
					if (!to) e.preventDefault();
					onOrderClick?.(orderMongoId);
				}}
				className={`${linkColorClass} text-decoration-none text-nowrap`}
			>
				<PendingKeywordHighlight text={orderId} />
			</Link>
			{recentlyEntered ? (
				<PendingThemeBadge bg='primary' pill className='pending-order-id-new-badge'>
					NEW
				</PendingThemeBadge>
			) : null}
		</div>
	);
};

export default PendingOrderIdCell;
